import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthRepository, UserRole } from '../auth.repository';

/** The translation workspace is for translators and SuperUser/SysAdmin only. */
@Injectable({ providedIn: 'root' })
export class TranslatorRoleGuard implements CanActivate {
  constructor(private authRepository: AuthRepository, private router: Router) {}

  canActivate(): boolean {
    const role = this.authRepository.getUser()?.role;
    if (role === UserRole.Translator || role === UserRole.SuperUser || role === UserRole.SysAdmin) {
      return true;
    }
    this.router.navigate(['/home']);
    return false;
  }
}
